import script from "./PriceshowInternetConfigModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceshowInternetConfigModal.vue?vue&type=script&setup=true&lang=ts"

import "./PriceshowInternetConfigModal.vue?vue&type=style&index=0&id=6f7d2258&lang=scss"

const __exports__ = script;

export default __exports__